module.exports = __webpack_public_path__ + "img/web-home-logo.93cb766f.png";